import ErrorBoundary from "@/components/shared/ErrorBoundary";
import { AdministrasjonTab } from "@/components/project/AdministrasjonTab";
import { useProjectDetailContext } from "@/contexts/ProjectDetailContext";

export default function AdminPage() {
  const { project, customer, allUsers, invoices } = useProjectDetailContext();
  return (
    <ErrorBoundary>
      <AdministrasjonTab
        project={project}
        customer={customer}
        allUsers={allUsers}
        invoices={invoices}
      />
    </ErrorBoundary>
  );
}
